import { InputBase_v2 } from './InputBase_v2'
import { ButtonSubmit } from './Buttons/ButtonSubmit'
import * as service from '~/api/requests'
import * as notification from '~/ToastGenerator'
import { createActView } from '~/legacy/request.edit/ActList'
import adoptAct from '~/legacy/request.edit/adapters/act'

const ActSearchForm = {
	data: () => ({
		name: null,
		loading: false,
	}),
	methods: {
		checkAct(event) {
			event.preventDefault()

			if (this.loading) return

			this.laoding = true

			service.getActByName(this.name)
				.then((response) => {
					if (!response.status) throw new Error(response.error)
					return response
				})
				.then(({ data: act }) => createActView(adoptAct(act)))
				.catch((error) => notification.error({
					heading: 'Ошибка',
					text: error.message,
					autohide: true,
					delay: 5000,
				}))
				.finally(() => this.loading = false)
		},
	},
	render(h) {
		return (
			<form onSubmit={ this.checkAct }>
				<InputBase_v2
					label="Номер акта"
					name="name"
					type="text"
					value={ this.name }
					vOn:input={ (value) => this.name = value }
				/>
				<ButtonSubmit
					class="mt-5"
					loading={ this.loading }
				/>
			</form>
		)
	},
}

export default ActSearchForm
